export default __webpack_public_path__ + "static/media/sign-up.3c202e48.svg";